import React, {lazy, useState} from 'react';
import CustomModal from "../../../components/UI/CustomModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {Drawer} from "antd";
import {Btn, ErrorText, FlexColumnSection, FlexRowSection, SmallHeader} from "../../../styles/globalStyles";
import {t} from "i18next";
import {useDispatch} from "react-redux";
import {SELECT_DATE_MODAL, updateModalRes} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {checkIfDateBeforeToday} from "../../../helpers/functions";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
const CustomDatePicker = lazy(() => import(/* webpackChunkName: "CustomDatePicker" */'../../../components/UI/CustomDatePicker'));
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {updateFlags} from "@arboxappv4/shared/src/redux/stepperSlice";

const SelectDate = (props) => {
    const { isOpen, onClose, header, defaultDate} = props;
    const [date, setDate] = useState(null);
    const [showError, setShowError] = useState(false);
    const {isMobile} = useScreenSize();
    const dispatch = useDispatch()

    const closeModal = () => {
        dispatch(updateFlags({closedDateModal: true}))
        onClose()
    }

    const getDatePickerComp = () => {
        return (
            <FlexColumnSection gap={'20px'}>
                <FlexRowSection justify={'space-between'}>
                    {header && <SmallHeader fontSize={'18px'}>{header}</SmallHeader>}
                    {isMobile && <div onClick={closeModal}><FontAwesomeIcon icon={light('x')} color={Colors.siteBlack} size={'xs'}/></div>}
                </FlexRowSection>
                <FlexColumnSection gap={'10px'}>
                    <CustomDatePicker onDateSelect={(val) => setDate(val)}
                                      disabledDate={checkIfDateBeforeToday}
                                      defaultDate={defaultDate}
                    />
                    {showError && <ErrorText>{t('select-date-error')}</ErrorText>}
                </FlexColumnSection>
                <FlexRowSection gap={'10px'} justify={'end'}>
                    <Btn onClick={closeModal}>{t('close')}</Btn>
                    <Btn type={'primary'} onClick={() => onDateSelected(date)}>{t('proceed')}</Btn>
                </FlexRowSection>
            </FlexColumnSection>
        )
    }

    const onDateSelected = () => {
        if(date) {
            dispatch(updateFlags({closedDateModal: false}))
            setShowError(false)
            dispatch(updateModalRes({modalName: SELECT_DATE_MODAL, res: date}))
            onClose()
        } else {
            setShowError(true)
        }
    }

    return (
        <>
            {
                isMobile ?
                    <Drawer classNames={{body: 'select-date-mobile-drawer-body'}}
                        placement={'bottom'}
                        closable={false}
                        onClose={closeModal}
                        open={isOpen}
                        style={{borderTopLeftRadius: 20, borderTopRightRadius: 20}}
                    >
                        {getDatePickerComp()}
                    </Drawer>
                    :
                    <CustomModal open={isOpen} onCancel={closeModal} width={'500px'}>
                        {getDatePickerComp()}
                    </CustomModal>
            }
        </>

    );
};

export default SelectDate;